<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.prd.monthPlanList')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/monthPlan"><span>{{$t('tlt.monthPlan')}}</span></router-link></li>
                </ul>
            </div>                       
            <div class="col-lg-2">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('monthPlan')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
           <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row" id="form" >
                                <div class="form-group col-md-2">
                                        <label class="control-label"><span class="lbl-required"></span>{{$t('lbl.monthPlan.code')}}:</label>
                                        <input class="form-control" type="text" v-model="codeFilter">
                                </div>
                                <div class="form-group col-md-2">
                                        <label class="control-label"><span class="lbl-required"></span>{{$t('lbl.monthPlan.locName')}}:</label>
                                        <input class="form-control" type="text" v-model="locNameFilter">
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.monthPlan.startDate')}}：</label>
                                    <mmf-monthpicker      v-model="startDateFilter"></mmf-monthpicker>                                                     
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.monthPlan.endDate')}}：</label>
                                    <mmf-monthpicker      v-model="endDateFilter"></mmf-monthpicker>
                                </div>  
                                <div class="form-group col-md-2">
                                        <label class="control-label"><span class="lbl-required"></span>{{$t('lbl.monthPlan.status')}}:</label>
                                        <!-- <input class="form-control" type="text" v-model="statusFilter"> -->
                                        <select class="form-control" type="text" v-model="statusFilter">
                                            <option value>{{ $t("lbl.basic.select.one") }}</option>
                                            <option value="N">{{ $t("lbl.monthPlan.new") }}</option>
                                            <option value="S">{{ $t("lbl.monthPlan.scheduled") }}</option>                                            
                                            <option value="C">{{ $t("lbl.monthPlan.cancled") }}</option>
                                        </select>
                                </div>                     
                                <div class="col align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('monthPlan')"><i class="fa fa-fw fa-lg fa-eraser"></i><span class=text>{{$t('btn.basic.clear')}}</span></button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('monthPlan')"><i class="fa fa-fw fa-lg fa-search"></i><span class=text>{{$t('btn.basic.search')}}</span></button>
                                    </div>                                                        
                                </div>  
                            </form>
                        </div>
                     </div>   
                </div>
            </div>
            <div id="monthPlanResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="monthPlan" inline-actions-disabled :singleChoice='true'>
                                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="monthPlanGenerateShiftPlan(entity)"                                >
                                        <i class="fa fa-tasks" aria-hidden="true"></i>                                   
                                        <span class="text">{{ $t("btn.monthPlan.generateShiftPlan") }}</span>
                                    </button>                                   
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <echart v-if="option.dataArray.length !=0" :optionSet="option" ></echart> -->
        </section>
    </div>
    
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionPlan/MonthPlan";
import MmfTable from "@/components/MmfTable";
import MmfMonthpicker from '@/components/MmfMonthpicker';
import echart from '@/components/MmfEcharts/MmfEcharts.vue'

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'monthPlan/getField',
    mutationType: 'monthPlan/updateField',
});

export default {
  name: "monthPlanList",
  data () {
    return {
    }
  },
  components: { MmfTable, MmfMonthpicker,echart},
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.monthPlan.rows,
            option:function(state){
              return {
                dataArray:state.monthPlan.rows,
                xName:'code',
                xIndex:'0',
                yName:['output'],
                chartType:'verticalPie',
                title:'测试用图'
              }
          },
    //   checkedItems: []
            checkedItems: state => state.monthPlan.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields,
            entity: state => state.monthPlan.entity,
        })
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),

    ...mapActions("monthPlan", ["monthPlanGenerateShiftPlan"]),
  },
  mounted(){
  }
};
</script>
